document.querySelectorAll('.product_nutritional_facts_button').forEach(button => {
  button.addEventListener('click', (e) => {
    e.stopPropagation();
    const popup = button.parentElement.querySelector('.product_nutritional_facts_popup_container');
    if (popup) {
      popup.style.display = 'block';
      // document.body.classList.add('overflow_hidden');
    }
  });
});

document.querySelectorAll('.product_nutritional_facts_popup_main .close').forEach(closeBtn => {
  closeBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    const popup = closeBtn.closest('.product_nutritional_facts_popup_container');
    if (popup) {
      popup.style.display = 'none';
      // document.body.classList.remove('overflow_hidden');
    }
  });
});
// document.addEventListener('click', (e) => {
//   document.querySelectorAll('.product_nutritional_facts_popup_container').forEach(popup => {
//     const popupInner = popup.querySelector('.product_nutritional_facts_popup_main');
//     if (
//       popup.style.display === 'block' &&
//       popupInner &&
//       !popupInner.contains(e.target)
//     ) {
//       popup.style.display = 'none';
//       // document.body.classList.remove('overflow_hidden');
//     }
//   });
// });